import { Component } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash-es'
import ReactTextareaAutosize from 'react-textarea-autosize'

export default class TextArea extends Component {
  handleChange = event => {
    const { name } = this.props
    const { value } = event.target
    const data = { name, value }
    this.props.onChange(data)
  }

  handleBlur = () => {
    this.props.onBlur()
  }

  render() {
    const { id, name, value, className, spellCheck, autoSize, disabled, style } = this.props
    if (autoSize) {
      return (
        <ReactTextareaAutosize
          className={className}
          id={id}
          name={name}
          value={value}
          spellCheck={spellCheck}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          disabled={disabled}
          minRows={2}
          style={style}
        />
      )
    } else {
      return (
        <textarea
          className={className}
          id={id}
          name={name}
          value={value}
          spellCheck={spellCheck}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          disabled={disabled}
          style={style}
        />
      )
    }
  }
}
TextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  spellCheck: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  autoSize: PropTypes.bool,
  disabled: PropTypes.bool,
}
TextArea.defaultProps = {
  id: null,
  value: undefined,
  spellCheck: null,
  className: null,
  style: null,
  onChange: noop,
  onBlur: noop,
  autoSize: true,
  disabled: false,
}
